var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Skeleton, Fade } from "@mui/material";
import { combineSxProps } from "../../Utils";
export const ThumbnailActions = (props) => {
    const { children, disabled, selected, loading, forceHover, rightActions, leftActions, label, lowerAdornment, showActions = "onHover", ContentProps, sx } = props, boxProps = __rest(props, ["children", "disabled", "selected", "loading", "forceHover", "rightActions", "leftActions", "label", "lowerAdornment", "showActions", "ContentProps", "sx"]);
    const [isMouseOver, setIsMouseOver] = useState(false);
    const hovered = forceHover || isMouseOver;
    return _jsxs(Box, Object.assign({ sx: combineSxProps(wrapperSxProps, sx), onMouseEnter: () => setIsMouseOver(true), onMouseLeave: () => setIsMouseOver(false) }, boxProps, { children: [_jsxs(Box, Object.assign({}, ContentProps, { sx: combineSxProps(ContentSxProps(selected, hovered, disabled), ContentProps === null || ContentProps === void 0 ? void 0 : ContentProps.sx), children: [loading
                        ? _jsx(Box, { sx: { width: "100%", height: "100%", position: "absolute", backgroundColor: "common.white", zIndex: 1 }, children: _jsx(Skeleton, { sx: { width: "100%", height: "100%" }, variant: "rectangular" }) })
                        : _jsx(_Fragment, {}), children, rightActions && !loading && !disabled
                        ? _jsx(Fade, { in: (showActions === "onHover" && hovered) || showActions === "always", timeout: 200, children: _jsx(Box, { sx: combineSxProps(actionsWrapperSxProps, { right: "8px" }), children: rightActions }) })
                        : null, leftActions && !loading && !disabled
                        ? _jsx(Fade, { in: (showActions === "onHover" && hovered) || showActions === "always", timeout: 200, children: _jsx(Box, { sx: combineSxProps(actionsWrapperSxProps, { left: "8px" }), children: leftActions }) })
                        : null] })), label || lowerAdornment
                ? _jsxs(Box, { sx: { display: "flex", gap: "4px", alignItems: "center", justifyContent: label ? "space-between" : "end" }, children: [label, lowerAdornment] })
                : null] }));
};
const wrapperSxProps = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "fit-content"
};
const ContentSxProps = (selected, hovered, disabled) => ({
    display: "flex",
    position: "relative",
    borderRadius: "8px",
    border: "2px solid transparent",
    boxShadow: theme => selected
        ? `0 0 0 2px ${theme.palette.primary.main}`
        : (hovered && !disabled)
            ? `0 0 0 2px ${theme.palette.primary.light}`
            : `0 0 0 1px ${theme.palette.divider}`,
    transition: "box-shadow 0.2s ease-in-out",
    overflow: "hidden",
    width: "100%",
    height: "100%",
    opacity: disabled ? 0.5 : 1,
    justifyContent: "center",
    backgroundColor: theme => theme.palette.grey[50],
    isolation: "isolate"
});
const actionsWrapperSxProps = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    position: "absolute",
    top: "8px"
};
//# sourceMappingURL=ThumbnailActions.js.map